import React, { useState, useRef } from 'react';
import { StarIcon, PlayIcon, PauseIcon, CheckCircleIcon, Volume2Icon } from 'lucide-react';
export function FeaturedTestimonial() {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);
  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  // Generate random heights for the waveform
  const waveformBars = Array.from({
    length: 36
  }).map((_, i) => {
    const height = Math.floor(Math.random() * 20) + 8; // 8px to 28px
    return <div key={i} className={`w-1 rounded-full transition-all duration-300 ${isPlaying ? 'bg-burnt animate-pulse' : 'bg-forest/40'}`} style={{
      height: `${height}px`
    }} data-id="element-144" />;
  });
  return <section id="testimonial" className="bg-forest-light py-12 md:py-16 px-5 scroll-mt-8" data-id="element-145">
      <div className="max-w-3xl mx-auto text-center" data-id="element-146">
        {/* Eyebrow */}
        <p className="font-sans text-sm font-semibold uppercase tracking-widest text-burnt-light mb-8" data-id="element-147">
          Hear From A Real Customer
        </p>

        {/* Large Card */}
        <div className="bg-white rounded-2xl p-8 md:p-10 shadow-2xl max-w-2xl mx-auto text-left relative" data-id="element-148">
          {/* Top Row: Avatar & Info */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6" data-id="element-149">
            <div className="w-16 h-16 rounded-full flex-shrink-0 flex items-center justify-center shadow-inner" style={{
            background: 'linear-gradient(135deg, #74C69D 0%, #2D6A4F 100%)'
          }} data-id="element-150">
              <span className="text-white font-serif font-bold text-xl" data-id="element-151">
                RH
              </span>
            </div>

            <div className="flex-1" data-id="element-152">
              <h3 className="font-bold text-forest text-xl font-sans" data-id="element-153">
                Robert Henderson
              </h3>
              <p className="text-gray-500 text-sm font-sans" data-id="element-154">
                Denver, Colorado
              </p>
              <div className="flex items-center gap-1 mt-1" data-id="element-155">
                <CheckCircleIcon className="w-3.5 h-3.5 text-forest" data-id="element-156" />
                <span className="text-forest text-xs font-semibold font-sans" data-id="element-157">
                  Verified Buyer
                </span>
              </div>
            </div>

            {/* Stars */}
            <div className="flex gap-0.5 self-start sm:self-center" data-id="element-158">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-159" />)}
            </div>
          </div>

          {/* Quote */}
          <blockquote className="text-lg text-gray-700 leading-relaxed italic font-serif mb-8" data-id="element-160">
            "I was about to give up gardening altogether. For three winters in a
            row I lost everything, until I met Jonathan through an
            advertisement..."
          </blockquote>

          {/* Audio Player — more eye-catching */}
          <div className="bg-forest/5 rounded-2xl p-4 border border-forest/15" data-id="element-161">
            {/* Listen prompt */}
            <div className="flex items-center gap-2 mb-3" data-id="element-162">
              <Volume2Icon className="w-4 h-4 text-forest" data-id="element-163" />
              <span className="font-sans text-forest text-sm font-semibold" data-id="element-164">
                🎧 Tap to listen to Robert's full story
              </span>
            </div>

            <div className="bg-white rounded-full px-4 py-3 flex items-center gap-3 shadow-sm border border-cream-dark" data-id="element-165">
              <audio ref={audioRef} src="https://cdn.magicpatterns.com/uploads/b6bs42EF7QWHETDe5CQPXX/202603241132.mp4" onEnded={() => setIsPlaying(false)} className="hidden" data-id="element-166" />
              <button onClick={togglePlay} className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-burnt ${isPlaying ? 'bg-forest hover:bg-forest-dark' : 'bg-burnt hover:bg-burnt-dark cta-pulse'}`} aria-label={isPlaying ? 'Pause audio testimonial' : 'Play audio testimonial'} data-id="element-167">
                {isPlaying ? <PauseIcon className="w-6 h-6 text-white" fill="currentColor" data-id="element-168" /> : <PlayIcon className="w-6 h-6 text-white ml-0.5" fill="currentColor" data-id="element-169" />}
              </button>

              <div className="flex-1 flex items-center gap-1 h-8 overflow-hidden px-2" data-id="element-170">
                {waveformBars}
              </div>

              <span className="text-gray-500 text-sm font-mono ml-auto flex-shrink-0" data-id="element-171">
                0:20
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}